import { Injectable, Optional } from '@angular/core';
import { Subject } from 'rxjs';
import {
  AppConfig,
  LAYOUT_CONFIG_DEFAULTS,
  mergeLayoutConfigWithDefaults,
  readStoredLayoutConfig,
  writeStoredLayoutConfig,
} from './layout-config-storage';
import { UserPreferencesService } from 'src/app/services/user-preferences.service';

export type { AppConfig } from './layout-config-storage';

interface LayoutState {
  staticMenuDesktopInactive: boolean;
  overlayMenuActive: boolean;
  profileSidebarVisible: boolean;
  configSidebarVisible: boolean;
  staticMenuMobileActive: boolean;
  menuHoverActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  config: AppConfig = mergeLayoutConfigWithDefaults(
    LAYOUT_CONFIG_DEFAULTS,
    readStoredLayoutConfig(),
  );

  constructor(@Optional() private readonly userPreferencesService: UserPreferencesService | null) {}

  state: LayoutState = {
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
  };

  private configUpdate = new Subject<AppConfig>();

  private overlayOpen = new Subject<any>();

  configUpdate$ = this.configUpdate.asObservable();

  overlayOpen$ = this.overlayOpen.asObservable();

  onMenuToggle() {
    if (this.isOverlay()) {
      this.state.overlayMenuActive = !this.state.overlayMenuActive;
      if (this.state.overlayMenuActive) {
        this.overlayOpen.next(null);
      }
    }

    if (this.isDesktop()) {
      this.state.staticMenuDesktopInactive =
        !this.state.staticMenuDesktopInactive;
    } else {
      this.state.staticMenuMobileActive = !this.state.staticMenuMobileActive;

      if (this.state.staticMenuMobileActive) {
        this.overlayOpen.next(null);
      }
    }
  }

  showProfileSidebar() {
    this.state.profileSidebarVisible = !this.state.profileSidebarVisible;
    if (this.state.profileSidebarVisible) {
      this.overlayOpen.next(null);
    }
  }

  showConfigSidebar() {
    this.state.configSidebarVisible = true;
  }

  isOverlay() {
    return this.config.menuMode === 'overlay';
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return !this.isDesktop();
  }

  onConfigUpdate() {
    writeStoredLayoutConfig(this.config);
    this.configUpdate.next(this.config);
    // Persist the combined preferences to the backend whenever layout changes.
    this.userPreferencesService?.saveToBackend();
  }
}
